export const selectBlockTextBySide = (ctx, next) => {
    const { focusBlock, tail } = ctx;
    if (!focusBlock) {
        return;
    }
    const path = focusBlock.path;
    const { selection } = ctx.std;
    selection.setGroup('note', [
        selection.getInstance('text', {
            from: {
                path,
                index: tail ? focusBlock.model.text?.length ?? 0 : 0,
                length: 0,
            },
            to: null,
        }),
    ]);
    return next();
};
//# sourceMappingURL=select-block-text-by-side.js.map